import { ChevronRightIcon, InformationCircleIcon, ExclamationTriangleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { statusIcons } from '../upgradeHistoryColumns';
import { addSpaceBeforeEveryCapitalLetter } from 'components/HGForm/helpers';
import DateTimeCell from 'components/DeviceDetails/UpgradeHistory/DateTimeCell';

export const devicesUpgradeStatusColumn = [
    {
        Header: 'Device ID',
        accessor: 'Thing_ID',
        component: (item) => (
            <span
                className="text-muted-foreground"
                style={{ fontWeight: item?.PACK_SN ? 'light' : 'normal' }}
            >
                {item?.PACK_SN && (
                    <ChevronRightIcon className="w-4 h-4 inline mr-1 text-gray-300" />
                )}
                {item?.PACK_SN ?? item?.MASTER_SN ?? item.Thing_ID}
            </span>
        ),
    },
    {
        Header: 'Status',
        accessor: 'state',
        component: (item) => (
            <span className="text-muted-foreground flex items-center">
                {item?.UpgradeState?.includes('Complete') ||
                item?.UpgradeState === 'Failed'
                    ? statusIcons[item?.UpgradeState]
                    : statusIcons['other']}
                {addSpaceBeforeEveryCapitalLetter(item?.UpgradeState ?? '')}
            </span>
        ),
    },
    {
        Header: 'Last Updated',
        accessor: 'lastUpdatedTime',
        component: (item) => <DateTimeCell item={item} />,
    },
];

const logLevels = {
    0: { icon: <InformationCircleIcon className="w-4 h-4 inline mr-1" />, text: 'info' },
    1: {
        icon: (
            <ExclamationTriangleIcon className="w-4 h-4 inline mr-1 text-warning" />
        ),
        text: 'warning',
    },
    2: {
        icon: (
            <ExclamationCircleIcon className="w-4 h-4 inline mr-1 text-error" />
        ),
        text: 'error',
    },
};

export const upgradeEventLogsColumns = [
    {
        Header: 'Created At',
        accessor: 'ts',
        component: (item) => <DateTimeCell item={item} />,
    },
    {
        Header: 'Log Level',
        accessor: 'data',
        component: (item) => (
            <span className="text-muted-foreground flex items-center">
                {logLevels[item.data.LogLevel].icon}
                {logLevels[item.data.LogLevel].text}
            </span>
        ),
    },
    {
        Header: 'Message',
        accessor: 'data',
        component: (item) => (
            <span className="text-muted-foreground">{item.data.Message}</span>
        ),
    },
];
